import { HttpClient } from '@opallabs/api'
import loadWorkflow from '../loadWorkflow'

const postMoment = (moment) => HttpClient().post('/moments/v2/', moment)

const createMoment =
  ({ moment, relationships, callback, promise }) =>
  (dispatch, getState) => {
    const reduxState = getState()
    const workspaceId = reduxState.current_workspace_id
    const opalId = reduxState.current_opal_id
    if (!workspaceId) return false

    // eslint-disable-next-line no-unused-vars
    const { id, uuid, ...momentAttributes } = moment

    const momentToCreate = {
      data: {
        attributes: {
          ...momentAttributes,
        },
        type: 'moment',
      },
    }

    if (relationships) {
      momentToCreate.data.relationships = {}
      Object.keys(relationships).forEach((key) => {
        momentToCreate.data.relationships[key] = {
          data: relationships[key],
        }
      })
    }
    momentToCreate.data.attributes.brand_id = workspaceId
    momentToCreate.data.attributes.opal_id = opalId

    return postMoment(momentToCreate)
      .then((response) => {
        const data = dispatch(loadWorkflow(response.data))

        // callback is used on the Backbone side. Can be removed
        // once Moment Creator is converted to React.
        if (callback) callback(promise, data.payload.data)
        return data
      })
      .catch((err) => {
        console.log(err)
        throw err
      })
  }

export default createMoment
